module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "Cargar Puntos"
    },
    on: {
      "close": _vm.emitClose
    }
  }, [(_vm.errors.length) ? _c('div', [_c('div', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3"
  }, [_c('div', {
    staticClass: "mt-3 col-span-12 sm:col-span-12"
  }, _vm._l((_vm.errors), function(error) {
    return _c('div', {
      key: ("error-" + error),
      staticClass: "bg-red-800 border border-red-600 rounded p-3 text-white",
      attrs: {
        "role": "alert"
      }
    }, _vm._l((error), function(singleError) {
      return _c('div', {
        key: ("singleError-" + singleError)
      }, [_vm._v("\n            - " + _vm._s(singleError) + "\n          ")])
    }), 0)
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "p-5 grid grid-cols-12 gap-4 row-gap-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.createActivity.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('label', [_vm._v("Archivo: (\n        "), _c('a', {
    staticClass: "text-blue-500 underline",
    attrs: {
      "href": "/v1/files/formats/upload-users-points-format.xlsx"
    }
  }, [_vm._v("Descargar formato")]), _vm._v("\n        )\n      ")]), _vm._v(" "), _c('input', {
    staticClass: "hidden",
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col mt-2 my-auto w-full"
  }, [(_vm.pointsUploader.file) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pointsUploader.fileName),
      expression: "pointsUploader.fileName"
    }],
    staticClass: "input w-full border",
    attrs: {
      "type": "text",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.pointsUploader.fileName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.pointsUploader, "fileName", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "button bg-theme-10 text-white button-sm",
    attrs: {
      "for": "file"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Cargar Archivo\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt-3 col-span-12"
  }, [_c('label', [_vm._v("Datos de las columnas:")]), _vm._v(" "), _c('div', {
    staticClass: "input w-full border mt-2"
  }, [_vm._v("\n        Evento: nombre del evento "), _c('br'), _vm._v("\n        Correo usuario: correo electrónico del usuario "), _c('br'), _vm._v("\n        Puntos: Numero de puntos (Numero entero, sin simbolos) "), _c('br'), _vm._v("\n        Tipo: 1 para Actividades 2 para Custom "), _c('br'), _vm._v("\n        Mes: Numero del mes (1 a 12) "), _c('br'), _vm._v("\n        Año: Numero del año "), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "col-span-12 px-5 py-3 text-right border-t border-gray-200"
  }, [_c('button', {
    staticClass: "button border text-gray-700 mr-1",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.emitClose
    }
  }, [_vm._v("\n        Cancelar\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "button bg-theme-1 text-white",
    attrs: {
      "type": "submit",
      "id": "edit"
    }
  }, [_vm._v("\n        Cargar Puntos\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15063329","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/points/ModalLoadPoints.vue
// module id = 411
// module chunks = 1